export const CHAT_HISTORY_TEST_IDS = {
  panel: 'chat-history-panel',
  search: 'chat-history-search',
  list: 'chat-history-list',
  item: 'chat-history-item',
  itemLoading: 'chat-history-item-loading',
  itemMenuButton: 'chat-history-item-menu-button',
  renameOption: 'chat-history-rename-option',
  deleteOption: 'chat-history-delete-option',
  loading: 'chat-history-loading',
  empty: 'chat-history-empty',
  loadError: 'chat-history-load-error',
  loadErrorRetry: 'chat-history-load-error-retry',
  openError: 'chat-history-open-error',
  openErrorRetry: 'chat-history-open-error-retry',
  loadMoreError: 'chat-history-load-more-error',
  loadMoreErrorRetry: 'chat-history-load-more-error-retry',
  sentinel: 'chat-history-sentinel',
  renameDialog: 'rename-conversation-dialog',
  renameDialogInput: 'rename-conversation-input',
  renameDialogSave: 'rename-conversation-save',
  renameDialogCancel: 'rename-conversation-cancel',
  renameDialogCounter: 'rename-conversation-counter',
  renameDialogError: 'rename-conversation-error',
  deleteDialog: 'delete-conversation-dialog',
  deleteDialogConfirm: 'delete-conversation-confirm',
  deleteDialogCancel: 'delete-conversation-cancel',
};
